// function accepts an array of time objects
// each object has startQuizTime and completeQuizTime properties
// substract start time from complete time and add the difference to accumulator

export default (arr = []) => {
  return arr.reduce((acc, obj) => {
    const { startQuizTime, completeQuizTime } = obj
    if (!isNaN(startQuizTime) && !isNaN(completeQuizTime)) {
      const totalTime = completeQuizTime - startQuizTime
      acc += totalTime
      return acc
    } else {
      return acc
    }
  }, 0)
}
